const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchBoats = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/boats/`);
    if (!response.ok) {
      throw new Error('Failed to fetch boats');
    }
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const fetchBoatDetails = async (boatId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/boats/${boatId}/`);
    if (!response.ok) {
      throw new Error(`Failed to fetch details for boat with ID ${boatId}`);
    }
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const addBoat = async (formData) => {
  for (let pair of formData.entries()) {
    console.log('DEBUG [addBoat] FormData entry:', pair[0], pair[1]);
  }
  try {
    const response = await fetch(`${API_BASE_URL}/admin/boats/`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error('Failed to add boat');
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const updateBoat = async (boatId, formData) => {
  for (let pair of formData.entries()) {
    console.log('DEBUG [updateBoat] FormData entry:', pair[0], pair[1]);
  }
  try {
    const response = await fetch(`${API_BASE_URL}/admin/boats/${boatId}/`, {
      method: 'PUT',
      body: formData,
    });

    if (!response.ok) {
      throw new Error('Failed to update boat');
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const deleteBoat = async (boatId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/boats/${boatId}/`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      throw new Error('Failed to delete boat');
    }
  } catch (error) {
    throw error;
  }
};

export const deleteBoats = async (boatIds) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/boats/bulk-delete/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        boat_ids: boatIds,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to delete boats');
    }
  } catch (error) {
    throw error;
  }
};

export const importBoats = async (importedFile) => {
  try {
    const formData = new FormData();
    formData.append('file', importedFile);

    const response = await fetch(`${API_BASE_URL}/admin/boats/import-csv/`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error('Failed to import boats');
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const addBoatGalleryImage = async (boatId, imageFormData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/boats/${boatId}/gallery/`, {
      method: 'POST',
      body: imageFormData,
    });

    if (!response.ok) {
      throw new Error('Failed to upload gallery image');
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};